import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "required",
  "use": "required-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"required\"><path d=\"M7.75 3.167H5.444l1.153-1.998L5.154.336 4 2.333 2.847.336l-1.443.833 1.154 1.998H.25v1.666h2.307L1.404 6.831l1.443.834 1.153-2 1.154 1.999 1.443-.833-1.153-1.998H7.75V3.167z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol